import { createSlice } from "@reduxjs/toolkit";
import axiosGeneral from "helpers/axios/axiosGeneral";
import { getCurrentToken } from "./authSlice";
import { selectData } from "./efficeCacheSlice";

export const slice = createSlice({
  name: "myReadEffices",
  initialState: {
    reads: {},
  },
  reducers: {
    updateReadEffice: (state, action) => {
      state.reads[action.payload.effId] = action.payload.read_subs;
    },
    unreadPendingEffice: (state, action) => {
      state.reads[action.payload.effId]--;
    },
    setMyReadEffices: (state, action) => {
      state.reads = action.payload;
    },
  },
});
export const { updateReadEffice, setMyReadEffices, unreadPendingEffice } =
  slice.actions;

// Get how much subs the client is aware of, then send this to the server
export const readThisEffice = (effId) => async (dispatch, getState) => {
  let read_subs = selectData(getState())[effId].sub_effices;
  if (!read_subs) return;
  getCurrentToken().then((idToken) => {
    axiosGeneral
      .post(`/effice/${effId}/read/${read_subs}`, null, {
        headers: {
          Authorization: "Bearer " + idToken,
        },
      })
      .then((response) => {
        window.efs_debug &&
          window.log(
            "Read Effice Response: " + JSON.stringify(response, null, 4)
          );
        dispatch(updateReadEffice({ effId, read_subs }));
      })
      .catch((error) => {
        window.efs_debug && window.log("Failed to set read effices in server");
        window.efs_debug && window.log(error);
      });
  });
};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectMyReadEffices = (state) => state.myReadEffices.reads;

export default slice.reducer;
